/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setUniqueEmailCollectionProperty, setCustomEmailCollectionImage, setCustomEmailCollectionPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import EmailCollection from 'material/embeds/content/contenttype/emailcollection/emailcollection';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : STORY : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    publisherName: embedsState.embedManagementState.contentStatus.addons.userDataCollection.publisherName,
    publisherPrivacyPolicyURL: embedsState.embedManagementState.contentStatus.addons.userDataCollection.publisherPrivacyPolicyURL,
    headline: embedsState.embedManagementState.contentStatus.addons.userDataCollection.headline,
    body: embedsState.embedManagementState.contentStatus.addons.userDataCollection.body,
    backgroundColor: embedsState.embedManagementState.contentStatus.addons.userDataCollection.backgroundColor,
    settingCustomEmailCollectionImage: embedsState.embedManagementState.contentStatus.settingCustomEmailCollectionImage,
    previewEmailCollectionBackgroundImageURL: embedsState.embedManagementState.contentStatus.previewEmailCollectionBackgroundImageURL,
    backgroundImageURL: embedsState.embedManagementState.contentStatus.addons.userDataCollection.backgroundImageURL,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
});

const mapDispatchToProps = dispatch => ({
    setUniqueEmailCollectionProperty: (property, value) => dispatch(setUniqueEmailCollectionProperty(property, value)),
    setCustomEmailCollectionImage: imageURL => dispatch(setCustomEmailCollectionImage(imageURL)),
    setCustomEmailCollectionPreviewImage: (imageURL) => dispatch(setCustomEmailCollectionPreviewImage(imageURL))

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailCollection);
